<section class="newsletter-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div class="newsletter-card">
          <div class="newsletter-badge">
            <span class="badge-text">Stay Updated</span>
          </div>
          
          <div class="newsletter-header">
            <h3>Subscribe to Our Newsletter</h3>
            <p>Stay updated with our latest services and industry insights</p>
          </div>
          
          <div class="newsletter-body">
            <!-- Success Message -->
            <div *ngIf="isSuccess" class="alert alert-success" role="alert">
              <i class="bx bx-check-circle"></i>
              {{ message }}
            </div>
            
            <!-- Error Message -->
            <div *ngIf="isError" class="alert alert-danger" role="alert">
              <i class="bx bx-error"></i>
              {{ message }}
            </div>
            
            <form #newsletterForm="ngForm" (ngSubmit)="onSubmit(newsletterForm)" *ngIf="!isSuccess">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <div class="input-wrapper">
                    <i class="bx bx-user"></i>
                    <input 
                      type="text" 
                      class="form-control" 
                      id="firstName" 
                      name="firstName" 
                      [(ngModel)]="firstName"
                      placeholder="First name">
                  </div>
                </div>
                
                <div class="col-md-6 mb-3">
                  <div class="input-wrapper">
                    <i class="bx bx-user"></i>
                    <input 
                      type="text" 
                      class="form-control" 
                      id="lastName" 
                      name="lastName" 
                      [(ngModel)]="lastName"
                      placeholder="Last name">
                  </div>
                </div>
                
                <div class="col-12 mb-3">
                  <div class="input-wrapper">
                    <i class="bx bx-envelope"></i>
                    <input 
                      type="email" 
                      class="form-control" 
                      id="email" 
                      name="email" 
                      [(ngModel)]="email"
                      placeholder="Email address *"
                      required
                      email>
                  </div>
                  <div class="invalid-feedback">
                    Please enter a valid email address.
                  </div>
                </div>
                
                <div class="col-12">
                  <button 
                    type="submit" 
                    class="btn btn-subscribe w-100" 
                    [disabled]="isSubmitting">
                    <span *ngIf="isSubmitting"><i class="bx bx-loader-alt bx-spin"></i> Subscribing...</span>
                    <span *ngIf="!isSubmitting"><i class="bx bx-paper-plane"></i> Subscribe Now</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>